<template>
  <div class="card card-blog">
    <div class="card-header card-header-image colored-shadow">
      <router-link
        :to="{ name: 'detail', params: { id: e.id, identifier: e.identifier } }"
      >
        <img
          rel="preload"
          class="img"
          :src="source_poster"
          @error="imageError = true"
          alt="IREAL experiment poster"
        />
      </router-link>
    </div>
    <div class="card-body">
      <institutionComponent
        :isProvided="true"
        :institution="e.institution"
      ></institutionComponent>
      <h4 class="card-category text-warning">
        {{ $t(`${e.identifier}_title`) }}
      </h4>
      <p class="card-description" v-html="truncatedDescription"></p>
      </p>
      <div class="m-0 md-layout md-gutter">
        <router-link
          :to="{ name: 'detail', params: { identifier: e.identifier } }"
          class="md-layout-item text-center mr-2 md-button md-info btn-lg"
          >{{ $t("description") }}</router-link
        >
        <router-link
          :to="{
            name: 'ireal',
            params: { identifier: e.identifier }
          }"
          class="md-layout-item text-center ml-2 md-button md-warning btn-lg"
          >{{ $t("experiment") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import IrealVue from "ireal-vue";
import componentMixin from "ireal-vue/mixins/component-mixin.js";

export default {
  name: "ExperienceTypeChooser",
  props: ["e"],
  mixins: [IrealVue.httpMixin, componentMixin],
  data() {
    return {
      experiences: [],
      institution: [],
      currentLocale: "en",
      imageError: false
    };
  },
  async created() {
    // we use httpMixin. request to have the list of experience. Fill array "experience" with results.
    //this.institution = await this.getObject("institution", this.e.institution);
  },

  computed: {
    source_poster() {
      return this.imageError
        ? `${this.IREALCONFIG.static_ressources}/default_poster.jpg`
        : `${this.IREALCONFIG.static_ressources}/labs/${this.e.identifier}/${this.e.identifier}_poster.jpg`;
    },
    truncatedDescription() {
    return this.$options.filters.truncate(this.$t(`${this.e.identifier}_description`), 190);
    }
  }
};
</script>
<style scoped>
.wrapper {
  margin: 15px;
}
router-link {
  padding: 5% !important;
}
</style>
